import { useContext } from "react";
import { NewVehicleContext } from "../context";

export const useNewVehicle = () => useContext(NewVehicleContext);
